import React, { useEffect, useState } from 'react'
import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { loadManualExportSnippet } from 'helper/manualUsuario'

/**
 * Renderiza um trecho extraído do manual do usuário definido em um bloco <export>.
 * @param {Object} props
 * @param {string} props.file Caminho do arquivo dentro de public/manualusuario (ex.: 'cadastro_produto_produto.md')
 * @param {string} props.exportId Valor do atributo id no bloco <export>
 * @param {string} [props.className] Classe extra para o contêiner externo
 * @param {React.ReactNode} [props.loading] Conteúdo exibido enquanto carrega
 * @param {React.ReactNode} [props.empty] Conteúdo exibido se nada for encontrado
 */
export default function ManualSnippet({ file, exportId, className = '', loading = 'Carregando orientação do manual…', empty = 'Trecho do manual não encontrado.' }) {
    const [content, setContent] = useState('')
    const [status, setStatus] = useState('loading') // loading | ready | empty

    useEffect(() => {
        let isMounted = true
        const fetchContent = async () => {
            setStatus('loading')
            const snippet = await loadManualExportSnippet({ file, exportId })
            if (!isMounted) return
            if (snippet) {
                setContent(snippet)
                setStatus('ready')
            } else {
                setContent('')
                setStatus('empty')
            }
        }
        fetchContent()
        return () => { isMounted = false }
    }, [file, exportId])

    if (status === 'loading') {
        return <div className={className}>{loading}</div>
    }

    if (status === 'empty') {
        return <div className={className}>{empty}</div>
    }

    return (
        <div className={className}>
            <Markdown remarkPlugins={[remarkGfm]}>
                {content}
            </Markdown>
        </div>
    )
}
